import request from '@/utils/request'

let VoucherApi = {

  /*券列表*/
  list(data) {
    return request._post('/shop/plus.voucher.Index/index', data);
},
/*添加券*/
add(data) {
    return request._post('/shop/plus.voucher.Index/add', data);
},
/*购买券*/
buy(data) {
    return request._post('/shop/plus.voucher.Index/buy', data);
},
/*修改券*/
edit(data) {
    return request._post('/shop/plus.voucher.Index/edit', data);
},
/*删除券*/
del(data) {
    return request._post('/shop/plus.voucher.Index/del', data);
},
/*券详情*/
detail(data) {
  return request._post('/shop/plus.voucher.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.voucher.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.voucher.Setting/getSetting', data, errorback);
    },
}
export default VoucherApi;



// WEBPACK FOOTER //
// ./src/api/voucher.js